export const RESET_PASSWORD_EMAIL = "RESET_PASSWORD_EMAIL"
export const RESET_PASSWORD_EMAIL_SUCCESS = "RESET_PASSWORD_EMAIL_SUCCESS"
export const RESET_PASSWORD_EMAIL_FAILED = "RESET_PASSWORD_EMAIL_FAILED"